<template>
  <div id="pdfs" v-loading="pdfLoading">
    <div class="pdf-pages" v-for="(obj, index) in pagesArr" :key="index">
      <canvas :id="compId + 'the-canvas' + index"></canvas>
    </div>
  </div>
</template>
<script>
import getPdfDoc from '@/lib/pdf'

export default {
  data() {
    return {
      pdfDoc: null,
      pdfLoading: true,
      pagesArr: [],
    }
  },
  props: {
    url: String,
    compId: {
      default: 1,
    },
    scale: {
      default: 1,
    },
    isSingle: {
      default: false,
    },
  },
  mounted() {
    const _this = this
    _this.showPDF(_this.url)
  },
  methods: {
    showPDF(url) {
      this.pdfLoading = true
      const _this = this

      getPdfDoc(url)
        .then(pdf => {
          _this.pdfDoc = pdf
          if (_this.isSingle) {
            _this.pagesArr.push(1)
            _this.renderPage(1)
          } else {
            for (let i = 0; i < pdf.numPages; i++) {
              _this.pagesArr.push(i)
              _this.renderPage(i + 1)
            }
          }
        })
        .finally(() => (_this.pdfLoading = false))
    },
    renderPage(num) {
      this.pageRendering = true
      const _this = this
      this.pdfDoc.getPage(num).then(function(page) {
        const viewport = page.getViewport(_this.scale)
        const canvas = document.getElementById(`${_this.compId}the-canvas${num - 1}`)
        canvas.height = viewport.height
        canvas.width = viewport.width
        // Render PDF page into canvas context
        const renderContext = {
          canvasContext: canvas.getContext('2d'),
          viewport,
        }
        /* eslint-disable */
        const renderTask = page.render(renderContext)
      })
    },
  },
}
</script>

<style scoped>
#pdfs {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.pdf-pages {
  box-shadow: 1px 1px 10px #aaa;
  margin: 20px 0;
}

.the-canvas {
  width: 100%;
}
</style>
